import { Theme } from '@mui/material';

export const enrichedFieldGradient = 'linear-gradient(90deg, #15E2DF 0%, #262ABC 100%)';
export const enrichmentInProgressGradient = 'linear-gradient(90deg, #15E2DF 0%, #111356 100%)';
export const aiActionGradient = 'linear-gradient(90deg, #16DEE0 0%, #484EFF 100%)';

export const getTextGradientStyles = (gradient: string) => ({
  background: gradient,
  'background-clip': 'text',
  color: 'transparent',
});

export const getBorderGradientStyles = (gradient: string, rounded?: boolean) => ({
  position: 'relative',
  '&:before': {
    content: "''",
    position: 'absolute',
    pointerEvents: 'none',
    inset: 0,
    borderRadius: rounded ? '50%;' : '10px',
    padding: '2px',
    background: gradient,
    mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
    maskComposite: 'exclude',
  },
});

const getTextFieldStyles = (gradient: string) => ({
  '& .LtOutlinedInput-root': {
    ...getBorderGradientStyles(gradient),
  },
  '& .LtOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .LtFormLabel-root': {
    background: 'white',
    paddingLeft: '5px',
    marginLeft: '-5px',
    paddingRight: '10px',
  },
});

export const enrichedTextFieldStyles = getTextFieldStyles(enrichedFieldGradient);
export const enrichmentInProgressTextFieldStyles = getTextFieldStyles(enrichmentInProgressGradient);

export const profilePicture_imgWrapperStyles = (theme: Theme) => ({
  width: '6.6rem',
  height: '6.6rem',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    width: '15rem',
    height: '15rem',
  },
  svg: { width: '100%', height: '100%' },
});

export const profilePicture_actionStyles = (theme: Theme) => ({
  width: '3rem',
  height: '3rem',
  borderRadius: '50%',
  position: 'absolute',
  bottom: 0,
  right: 0,
  bgcolor: 'primary.main',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    width: '5rem',
    height: '5rem',
  },
});

export const profilePicture_progressStyles = (theme: Theme) => ({
  width: '2.4rem',
  height: '2.4rem',
  borderRadius: '50%',
  position: 'absolute',
  bottom: '0rem',
  right: '-2.4rem',
  [theme.breakpoints.up('md')]: {
    right: '-4rem',
    width: '5rem',
    height: '5rem',
  },
});
